<ng-container>
  <!-- <div id="spinner"></div> -->
  <ejs-pdfviewer id="pdfViewer" [documentPath]="base64String" [toolbarSettings]="toolbarSettings" style="display: block; height: 100%; width: 100%">
  </ejs-pdfviewer>

  <div *ngIf="!(nodeEntry.entry.allowableOperations && nodeEntry.entry.allowableOperations.includes('download')) && nodeEntry">
    <app-watermark
      *ngIf="configWaterEnable"
      [lineOne]="lineOne"
      [lineTwo]="lineTwo"
      [maxFontSizeLineOne]="maxFontSizeLineOne"
      [maxFontSizeLineTwo]="maxFontSizeLineTwo"
      [colorLineOne]="colorLineOne"
      [colorLineTwo]="colorLineTwo"
      [opacityLineOne]="opacityLineOne"
      [opacityLineTwo]="opacityLineTwo"
      [displayLayout]="displayLayout"
      [maxColumns]="maxColumns"
      [rightTabOpen]="rightTabOpen"
      [reviewOnly]="true"
    >
    </app-watermark>
  </div>
</ng-container>
